export const terminal_command = {
	data() {
		return {
			default_functions: {
				bold: {
					placeholder: "Grassetto",
					description: "Grassetto",
					callback: this.bold,
					path: require("@/assets/icons/editor/bold.svg"),
					keyword: "grassettoboldstrong"
				},
				italic: {
					placeholder: "Corsivo",
					description: "Corsivo",
					callback: this.italic,
					path: require("@/assets/icons/editor/italic.svg"),
					keyword: "italiccorsivo"
				},
				strike: {
					placeholder: "Barrato",
					description: "Barra",
					callback: this.strike,
					path: require("@/assets/icons/editor/strikethrough.svg"),
					keyword: "strikelinea"
				},
				underline: {
					placeholder: "Sottolinea",
					description: "Sottolinea",
					callback: this.underline,
					path: require("@/assets/icons/editor/underline.svg"),
					keyword: "underlinesottolineato"
				},
				highlight: {
					placeholder: "Evidenzia",
					description: "Evidenzia",
					callback: this.highlight,
					path: require("@/assets/icons/editor/highlight.svg"),
					keyword: "highlightevidenzia"
				},
				title: {
					placeholder: "Titolo",
					description: "Make a title",
					callback: this.title,
					path: require("@/assets/icons/editor/heading_1.svg"),
					keyword: "titolotitleheadingh1"
				},
				title2: {
					placeholder: "Titolo2",
					description: "Make a title",
					callback: this.title2,
					path: require("@/assets/icons/editor/heading_2.svg"),
					keyword: "titolotitleheadingh2"
				},
				title3: {
					placeholder: "Titolo3",
					description: "Make a title",
					callback: this.title3,
					path: require("@/assets/icons/editor/heading_3.svg"),
					keyword: "titolotitleheadingh3"
				},
				bullet: {
					placeholder: "Elenco puntato",
					description: "A",
					callback: this.bullet,
					path: require("@/assets/icons/editor/bullet.svg"),
					keyword: "elencopuntatoulbulletlist"
				},
				ordered: {
					placeholder: "Elenco numerato",
					description: "B",
					callback: this.ordered,
					path: require("@/assets/icons/editor/ordered.svg"),
					keyword: "elenconumeratonumeroolorderedlista"
				},
				quote: {
					placeholder: "Citazione",
					description: "Cit.",
					callback: this.quote,
					path: require("@/assets/icons/editor/quote.svg"),
					keyword: "quoteblockcitazione"
				},
				link: {
					placeholder: "Link",
					description: "E",
					callback: this.link,
					path: require("@/assets/icons/editor/link.svg"),
					keyword: "linkcollegamentoweb"
				},
				normal: {
					placeholder: "Testo",
					description: "Testo normale",
					callback: this.normal,
					path: require("@/assets/icons/editor/text.svg"),
					keyword: "normaletestonormal"
				},
				table: {
					placeholder: "Tabella",
					description: "Crea una tabella",
					callback: this.table,
					path: require("@/assets/icons/editor/table.svg"),
					keyword: "tabletabella"
				},
				alignLeft: {
					placeholder: "Allinea a sinistra",
					description: "Sinistra",
					callback: this.alignLeft,
					path: require("@/assets/icons/editor/align_left.svg"),
					keyword: "alignleftallineasinistra"
				},
				alignCenter: {
					placeholder: "Allinea al centro",
					description: "Centro",
					callback: this.alignCenter,
					path: require("@/assets/icons/editor/align_center.svg"),
					keyword: "aligncenterallineacentro"
				},
				alignRight: {
					placeholder: "Allinea a destra",
					description: "Destra",
					callback: this.alignRight,
					path: require("@/assets/icons/editor/align_right.svg"),
					keyword: "alignrightallineadestra"
				},
				justify: {
					placeholder: "Giustifica",
					description: "Giustifica",
					callback: this.justify,
					path: require("@/assets/icons/editor/justify.svg"),
					keyword: "justifygiustifica"
				},
				colorBlack: {
					placeholder: "Testo nero",
					description: "Nero",
					callback: this.colorBlack,
					path: require("@/assets/icons/editor/color_black.svg"),
					keyword: "colorblacktestonerocolore"
				},
				colorRed: {
					placeholder: "Testo rosso",
					description: "Rosso",
					callback: this.colorRed,
					path: require("@/assets/icons/editor/color_red.svg"),
					keyword: "colorredtestorossocolore"
				},
				colorBlue: {
					placeholder: "Testo blu",
					description: "Blu",
					callback: this.colorBlue,
					path: require("@/assets/icons/editor/color_blue.svg"),
					keyword: "colorbluetestoblucolore"
				},
				colorGreen: {
					placeholder: "Testo verde",
					description: "Verde",
					callback: this.colorGreen,
					path: require("@/assets/icons/editor/color_green.svg"),
					keyword: "colorgreentestoverde"
				},
				colorGray: {
					placeholder: "Testo grigio",
					description: "Grigio",
					callback: this.colorGray,
					path: require("@/assets/icons/editor/color_gray.svg"),
					keyword: "colorgreytestogrigiocolore"
				},
				colorBrown: {
					placeholder: "Testo marrone",
					description: "Marrone",
					callback: this.colorBrown,
					path: require("@/assets/icons/editor/color_brown.svg"),
					keyword: "colorbrowntestomarronecolore"
				},
				colorYellow: {
					placeholder: "Testo giallo",
					description: "Giallo",
					callback: this.colorYellow,
					path: require("@/assets/icons/editor/color_yellow.svg"),
					keyword: "coloryellowtestogiallocolore"
				},
				colorPurple: {
					placeholder: "Testo viola",
					description: "Viola",
					callback: this.colorPurple,
					path: require("@/assets/icons/editor/color_purple.svg"),
					keyword: "colorpurpletestoviolacolore"
				}
			},
			functions_list: [],
			functionPlaceholder: this.$t("search"),
			functionDescription: "",
			selectedIndex: 0,
			stepperIndex: 0,
			selectedFunction: null,
			temp: [],
			currentFunc: "",
			selectedGlobal: null
		}
	},
	mounted() {
		this.loadFunctions()
	},
	methods: {
		loadFunctions() {
			this.functions_list = []
			let indice = 0
			for (const [key, value] of Object.entries(this.default_functions)) {
				let tmp = {}
				tmp.index = indice
				indice++
				tmp.name = key
				tmp.description = value.description
				tmp.placeholder = value.placeholder
				tmp.keyword = value.keyword
				tmp.callback = value.callback
				tmp.params = value.params
				tmp.path = value.path
				this.functions_list.push(tmp)
			}
		},
		changeSelectedFunction(element, index) {
			if (element !== undefined) {
				// tiene il focus sull'elemento selezionato
				if (element.index == 0) {
					if (this.$refs.scroller.childNodes[0])
						this.$refs.scroller.childNodes[0].scrollIntoView({ behavior: "smooth" })
				}
				if (element.index > 5 && this.$refs.scroller.childNodes.length > 2) {
					if (this.$refs.scroller.childNodes.length !== Object.keys(this.default_functions).length) {
						this.$refs.scroller.childNodes[
							Math.round(this.$refs.scroller.childNodes.length / 2)
						].scrollIntoView({ behavior: "smooth" })
					} else {
						this.$refs.scroller.childNodes[element.index - 2].scrollIntoView({ behavior: "smooth" })
					}
				}
				this.$nextTick(() => {
					const idx = this.filtered.findIndex(x => x.index === element.index)
					this.selectedIndex = idx
					this.functionPlaceholder = this.filtered[idx].placeholder
					this.functionDescription = this.filtered[idx].description
					if (index >= 0) this.confirmFunction(null, this.selectedIndex) // triggerata quando si clicca/preme invio
				})
			}
		},
		changeSelectedIndex(event, index) {
			event.preventDefault()
			if (this.selectedFunction === null) {
				if (this.filtered.length > 1) {
					// solo se ci sono almeno due elementi nella lista
					let i = this.selectedIndex // indice attuale
					switch (index) {
						// +1 sposta in giù, -1 sposta in su
						case 1:
							if (this.selectedIndex + 1 > this.filtered.length - 1) {
								i = 0
							} else {
								i++
							}

							break // se più lungo della lista torna al primo
						case -1:
							if (this.selectedIndex - 1 < 0) {
								i = this.filtered.length - 1
							} else {
								i--
							}

							break // se prima del primo torna all'ultimo
					}
					this.selectedIndex = i
				}
				this.changeSelectedFunction(this.filtered[this.selectedIndex]) // update della funzione selezionata
			}
		},
		deleteSearch() {
			if (this.selectedFunction !== null) {
				if (this.searchedText.length < 1) {
					this.stepperIndex = 0
					this.temp = []
					this.functionPlaceholder = "Cerca"
					this.confirmCallback = [this.confirmFunction]
					this.stepPhase = ""
					this.phaseLevel = "0%"
					this.currentFunc = ""
					this.searching = true
					this.selectedFunction = null
				}
			}
		},
		confirmFunction(event, idx = this.selectedIndex) {
			event ? event.preventDefault() : ""
			if (this.selectedFunction === null) {
				let element = this.filtered[idx]
				if (element !== undefined) {
					this.currentFunc = element.name
					// contiene i vari step nei casi in cui ci siano altrimenti null
					this.functionDescription = element.params || null
					this.selectedFunction = element
					this.stepSupport(this.stepperIndex)
				}
			} else {
				this.searchedText += " "
			}
			this.searchedText = ""
			this.searching = false
		},
		stepSupport(v) {
			// cambio funzione che manda allo stepper
			this.confirmCallback[0] = this.stepper
			if (this.functionDescription !== null) {
				// se ci sono params
				// pusha nel tempArray un nuovo elemento {descrizione, value -> indice (temporaneo)}
				this.temp.push({
					key: Object.keys(this.functionDescription)[this.stepperIndex],
					value: this.stepperIndex
				})

				this.functionPlaceholder = Object.keys(this.functionDescription)[this.stepperIndex]
			} else {
				this.selectedFunction.callback()
				this.closeCommandEditor(new Event("click", {}), 1)
			}
		},
		stepper() {
			// imposta nel tempArray i valori inseriti del comando
			this.temp[this.stepperIndex].value = this.$refs.command_input.value
			if (this.stepperIndex < Object.keys(this.functionDescription).length - 1) {
				// se i params non sono finiti reset campi, aumenta il phase e rimanda a stepSupport
				this.$refs.command_input.clear()
				this.$refs.command_input.focus()
				this.phaseLevel = `${
					((this.stepperIndex + 1) / Object.keys(this.default_functions[this.currentFunc].params).length) *
					100
				}%`
				this.stepSupport(this.stepperIndex++)
			} else {
				// esegue la funzione
				this.default_functions[this.currentFunc].callback(this.temp)
				this.closeCommandEditor(new Event("click", {}), 1)
			}
		},
		bold() {
			this.editor.chain().focus().toggleBold().run()
		},
		normal() {
			this.editor.chain().focus().setParagraph().run()
		},
		title() {
			this.editor.chain().focus().toggleHeading({ level: 1 }).run()
		},
		title2() {
			this.editor.chain().focus().toggleHeading({ level: 2 }).run()
		},
		title3() {
			this.editor.chain().focus().toggleHeading({ level: 3 }).run()
		},
		italic() {
			this.editor.chain().focus().toggleItalic().run()
		},
		underline() {
			this.editor.chain().focus().toggleUnderline().run()
		},
		strike() {
			this.editor.chain().focus().toggleStrike().run()
		},
		quote() {
			this.editor.chain().focus().toggleBlockquote().run()
		},
		bullet() {
			this.editor.chain().focus().toggleBulletList().run()
		},
		ordered() {
			this.editor.chain().focus().toggleOrderedList().run()
		},
		alignCenter() {
			this.editor.chain().focus().setTextAlign("center").run()
		},
		alignLeft() {
			this.editor.chain().focus().setTextAlign("left").run()
		},
		alignRight() {
			this.editor.chain().focus().setTextAlign("right").run()
		},
		table() {
			this.editor
				.chain()
				.focus()
				.insertTable({
					rows: 3,
					cols: 3,
					withHeaderRow: true
				})
				.run()
		},
		justify() {
			this.editor.chain().focus().setTextAlign("justify").run()
		},
		colorBlack() {
			this.editor.chain().focus().setColor("#000000").run()
		},
		colorRed() {
			this.editor.chain().focus().setColor("#F44336").run()
		},
		colorGreen() {
			this.editor.chain().focus().setColor("#8BC34A").run()
		},
		colorGray() {
			this.editor.chain().focus().setColor("#9E9E9E").run()
		},
		colorBrown() {
			this.editor.chain().focus().setColor("#795548").run()
		},
		colorYellow() {
			this.editor.chain().focus().setColor("#FFEE58").run()
		},
		colorBlue() {
			this.editor.chain().focus().setColor("#2196F3").run()
		},
		colorPurple() {
			this.editor.chain().focus().setColor("#9575CD").run()
		},
		highlight() {
			this.editor.chain().focus().toggleHighlight().run()
		},
		link() {
			const url = window.prompt("URL")
			this.editor.chain().focus().extendMarkRange("link").setLink({ href: url }).run()
		}
		// async insertVariable(e, el) {
		// 	e ? e.preventDefault() : ""
		// 	const prev = this.editor.root.innerHTML
		// 	const v = `<span> </span><span contentEditable="false" id="${el.index}" style="color:#000"'>_____</span><span> </span>`
		// 	let cursor = this.editor.getSelection(true).index
		//
		// 	var splitted = prev.split('<')
		//
		// 	for (var index = 1; index < splitted.length; index++) {
		// 		var splitted2 = splitted[index].split('>')
		// 		var text = splitted2[splitted2.length - 1]
		//
		// 		if (text.length >= cursor) {
		// 			splitted2[splitted2.length - 1] = text.slice(0, cursor) + v + text.slice(cursor);
		//
		// 			splitted[index] = splitted2.join('>')
		// 			break;
		// 		} else {
		// 			cursor -= text.length
		// 			if (splitted2[0] == "/td") cursor--
		// 		}
		// 	}
		//
		// 	var newvar = splitted.join('<')
		//
		// 	this.editor.root.innerHTML = ''
		// 	this.editor.root.innerHTML = `${newvar}`
		// },
	}
}

// "mail": {
// 	"params": {"mittente": "Chi invia","destinatario": "Indirizzo mail del destinatario","oggetto": "Oggetto della mail","testo": "Corpo della mail"},
// 	"placeholder": "Mail", "description": "invia rapidamente una mail", "callback": this.mail, "path": require('@/assets/icons/editor/mail.svg'),
// 	"keyword": "mailsendinviaemail"
// },
